import { motion } from 'motion/react';
import { useGetParams } from 'hooks/useGetParams';
import styles from './Title.module.css';
import { Line } from './Line';

export const Title = () => {
  const { title } = useGetParams();

  const advtlines = title?.split(/\\n/);

  return (
    <motion.div
      initial={{ maskPosition: '100% center' }}
      animate={{ maskPosition: '0% center' }}
      transition={{ duration: 1 }}
      className={styles.titleWrap}
      style={{ paddingBottom: advtlines.length === 1 && '2rem' }}
    >
      {advtlines.map((line, idx, arr) => (
        <motion.div
          transition={{ duration: 0.76 }}
          key={line + idx}
          className={styles.lineWrapper}
        >
          <Line
            line={line?.trim()}
            delayLine={(arr.length - 1 - idx) * 0.3}
            y={idx === 1 ? '-2rem' : 0}
            padding={
              idx === 1 || advtlines.length === 1
                ? '0.5rem 2rem 0.5rem 0.5rem'
                : '1rem 2rem 2rem 0.5rem'
            }
          />
        </motion.div>
      ))}
    </motion.div>
  );
};
